import api from "../config/api";
import { dataConfigType, getDataConfigType } from "./test/data-config";

export async function getOwner() {
  if (getDataConfigType() === dataConfigType.LIVEDATA) {
    const { data: { data: { users = [], defaultUserId } = [] } = [] } = await api.get(
      `${wbConfig.baseUrl}/restapi/engagementReport/usersFilter`
    );

    if (!users.length) {
      console.log('Org Engagement: No user levels found');
    }

    users.map(item => item.label = `${item.firstName} ${item.lastName}`);
    return { users: users, defaultUserId: defaultUserId };
  } else {
    return {
      users: [
        {
          id: 1,
          label: "Jane Smith"
        },
        {
          id: 2,
          label: "Don Draper"
        }
      ],
      defaultUserId: 1
    };
  }
}

export default {
  getOwner
};
